<app-app-shell>
  <router-outlet />
</app-app-shell>
